import React from 'react';

export default function SaveButton({ onSave, isSaving }) {
  return (
    <div className="p-4 border-t-2 border-gray-200 bg-white">
      <button
        onClick={onSave}
        disabled={isSaving}
        className={`w-full text-white rounded-lg p-4 font-semibold text-lg transition-colors ${isSaving ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
      >
        {isSaving ? 'Saving...' : 'Save Event'}
      </button>
    </div>
  );
}
